import React, { Fragment } from 'react';
import { Descriptions } from 'antd';
import { useStore } from 'routes/inventorize_meter/useStore';
import { ImageUploadReview } from 'components/ImageUpload/ImageUploadReview';
import { Tariff, UNIT_TRANSLATED } from '@enmon/commons';
import { FormattedMessage } from 'react-intl';
import { RegisterDescriptions as messages } from '../messages';

export const RegisterDescriptions: React.VFC = () => {
  const { registers } = useStore();

  return (
    <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }} size="small" title="Registry">
      {registers?.map((register, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <Descriptions.Item
            label={<FormattedMessage {...messages.registerName} values={{ register: index + 1 }} />}
            span={1}
          >
            {register.name}
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.obis} />} span={1}>
            {register.fullObis?.obis ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.tariff} />} span={1}>
            {register.fullObis?.tariff ?? Tariff.Zero}
          </Descriptions.Item>

          <Descriptions.Item label={<FormattedMessage {...messages.registerStatus} />} span={1}>
            {register.readingCounter} {register.unit && UNIT_TRANSLATED[register.unit]}
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.registerPhotos} />} span={2}>
            <ImageUploadReview fileList={register.readingPhotos} previewWidth={150} />
          </Descriptions.Item>
        </Fragment>
      ))}
    </Descriptions>
  );
};
